import {
  AuditOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CarOutlined,
  CloudServerOutlined,
  DesktopOutlined,
  DollarOutlined,
  GiftOutlined,
  GoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  PictureOutlined,
  SelectOutlined,
  SettingOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  BarcodeOutlined,
  BuildOutlined,
  SlidersOutlined,
  OneToOneOutlined,
  EuroCircleOutlined,
  AppstoreOutlined,
  NotificationOutlined,
  PhoneOutlined,
  MessageOutlined,
  ScheduleOutlined,
  NodeIndexOutlined,
  LineChartOutlined,
  KeyOutlined,
  MedicineBoxOutlined,
  IssuesCloseOutlined,
  CheckCircleOutlined,
  AccountBookOutlined,
  FlagOutlined,
  LaptopOutlined,
  Loading3QuartersOutlined,
  BankOutlined,
  PercentageOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";
import { Layout, Menu, notification } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  IoAirplane,
  IoAlertOutline,
  IoApertureOutline,
  IoBagAddOutline,
  IoBoatOutline,
  IoCashOutline,
  IoCheckmarkCircle,
  IoCheckmarkCircleOutline,
  IoCog,
  IoDocument,
  IoDocumentOutline,
  IoExpandOutline,
  IoImage,
  IoImageOutline,
  IoPaperPlane,
  IoSparkles,
  IoSparklesOutline,
  IoStar,
  IoStarOutline,
} from "react-icons/io5";
import SubMenu from "antd/es/menu/SubMenu";
import { logoutAdmin } from "../actions/AuthAction";
import { isPermitted } from "../utils/PermissionManager";
import { FiLoader } from "react-icons/fi";
import { BsCheck2Square, BsCurrencyDollar, BsListCheck } from "react-icons/bs";
import { BiDollarCircle, BiEuro } from "react-icons/bi";
//   import { sidebarItems } from "../utils/Sidebars";
const { Sider } = Layout;

export default function SideMenu(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const roles = useSelector((state) => state.auth.profile?.roles);
  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const menuStyle = {
    fontSize: "16px",
    width: "18px",
  };

  return (
    <Menu
      theme="light"
      mode="inline"
      defaultSelectedKeys={[path.toString()]}
      defaultOpenKeys={["accounts"]}
    >
      <Menu.Item key={"/"} icon={<HomeOutlined style={menuStyle} />}>
        <Link to={"/"}>Dashboard</Link>
      </Menu.Item>

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item key={"/customers"} icon={<TeamOutlined style={menuStyle} />}>
          <Link to={"/customers"}>Customers</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, [
        "admin",
        "bn_purchase",
        "cn_purchase",
        "order",
        "customer_care",
      ]) && (
        <Menu.Item key={"/orders"} icon={<GoldOutlined style={menuStyle} />}>
          <Link to={"/orders"}>Orders</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["admin"]) && (
        <Menu.Item
          key={"/sea-orders"}
          icon={<IoBoatOutline style={menuStyle} />}
        >
          <Link to={"/sea-orders"}>Sea</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item
          key={"/airport-damaged"}
          icon={<IoAirplane style={menuStyle} />}
        >
          <Link to={"/airport-damaged"}>Airport Damaged</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
        <Menu.Item key={"/risky"} icon={<AuditOutlined style={menuStyle} />}>
          <Link to={"/risky"}>Risky</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
        <SubMenu
          key="auto-purchase"
          icon={<IoBagAddOutline style={menuStyle} />}
          title="Auto Purchase"
        >
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/pending-orders"}
              icon={<IoExpandOutline style={menuStyle} />}
            >
              <Link to={"/pending-orders"}>Pending Orders</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/approved-orders"}
              icon={<IoCheckmarkCircleOutline style={menuStyle} />}
            >
              <Link to={"/approved-orders"}>Approved Orders</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/ready-sheets"}
              icon={<IoDocumentOutline style={menuStyle} />}
            >
              <Link to={"/ready-sheets"}>Ready Sheets</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/waiting-orders"}
              icon={<IoSparklesOutline style={menuStyle} />}
            >
              <Link to={"/waiting-orders"}>Waiting Orders</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/manual-purchase"}
              icon={<IoAlertOutline style={menuStyle} />}
            >
              <Link to={"/manual-purchase"}>Manual Purchase</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/supplier-confirmation"}
              icon={<IoCheckmarkCircleOutline style={menuStyle} />}
            >
              <Link to={"/supplier-confirmation"}>Supplier Confirmation</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/auto-purchase-verification"}
              icon={<BsCheck2Square style={menuStyle} />}
            >
              <Link to={"/auto-purchase-verification"}>Auto Verification</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/purchase-payment-confirmation"}
              icon={<BiDollarCircle style={menuStyle} />}
            >
              <Link to={"/purchase-payment-confirmation"}>Payment Sheet</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/auto-payment"}
              icon={<BiEuro style={menuStyle} />}
            >
              <Link to={"/auto-payment"}>Auto Payment</Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
        <SubMenu
          key="purchase"
          icon={<IoBagAddOutline style={menuStyle} />}
          title="Purchase"
        >
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/air-purchase-new"}
              icon={<IoPaperPlane style={menuStyle} />}
            >
              <Link to={"/air-purchase-new"}>Air Purchase</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/sea-purchase-new"}
              icon={<IoBoatOutline style={menuStyle} />}
            >
              <Link to={"/sea-purchase-new"}>Sea Purchase</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/skyone-purchase"}
              icon={<MedicineBoxOutlined style={menuStyle} />}
            >
              <Link to={"/skyone-purchase"}>SkyOne Purchase</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/incomplete-purchase"}
              icon={<IssuesCloseOutlined style={menuStyle} />}
            >
              <Link to={"/incomplete-purchase"}>Incomplete Purchase</Link>
            </Menu.Item>
          )}

          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/customer-confirmation"}
              icon={<FiLoader style={menuStyle} />}
            >
              <Link to={"/customer-confirmation"}>Customer Confirmation</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/logistic-confirmation"}
              icon={<BsCheck2Square style={menuStyle} />}
            >
              <Link to={"/logistic-confirmation"}>Logistic Confirmation</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/supplier-confirmation"}
              icon={<IoCheckmarkCircleOutline style={menuStyle} />}
            >
              <Link to={"/supplier-confirmation"}>Supplier Confirmation</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/auto-purchase-verification"}
              icon={<BsCheck2Square style={menuStyle} />}
            >
              <Link to={"/auto-purchase-verification"}>Auto Verification</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/purchase-payment-confirmation"}
              icon={<BiDollarCircle style={menuStyle} />}
            >
              <Link to={"/purchase-payment-confirmation"}>Payment Sheet</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/auto-payment"}
              icon={<BiEuro style={menuStyle} />}
            >
              <Link to={"/auto-payment"}>Auto Payment</Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
        <SubMenu
          key="tracking"
          icon={<BarcodeOutlined style={menuStyle} />}
          title="Tracking"
        >
          {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
            <Menu.Item
              key={"/tracking"}
              icon={<BarcodeOutlined style={menuStyle} />}
            >
              <Link to={"/tracking"}>Manual Tracking</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "tracking"]) && (
            <Menu.Item
              key={"/auto-tracking"}
              icon={<KeyOutlined style={menuStyle} />}
            >
              <Link to={"/auto-tracking"}>Auto Tracking</Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {isPermitted(roles, ["admin", "bd_purchase", "cn_purchase"]) && (
        <Menu.Item key={"/sorting"} icon={<BsListCheck style={menuStyle} />}>
          <Link to={"/sorting"}>Sorting</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["admin", "shipment"]) && (
        <SubMenu
          key="shipping-charges"
          icon={<BsCurrencyDollar style={menuStyle} />}
          title="Shipping Charges"
        >
          {isPermitted(roles, ["admin", "shipment"]) && (
            <Menu.Item
              key={"/shipping-categories"}
              icon={<BsListCheck style={menuStyle} />}
            >
              <Link to={"/shipping-categories"}>Categories</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["admin", "shipment"]) && (
            <Menu.Item
              key={"/shipping-charges"}
              icon={<BsCurrencyDollar style={menuStyle} />}
            >
              <Link to={"/shipping-charges"}>Charges</Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {isPermitted(roles, ["admin", "shipment"]) && (
        <Menu.Item key={"/qc"} icon={<ExperimentOutlined style={menuStyle} />}>
          <Link to={"/qc"}>QC</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["admin", "shipment"]) && (
        <Menu.Item
          key={"/qc-customer"}
          icon={<ScheduleOutlined style={menuStyle} />}
        >
          <Link to={"/qc-customer"}>QC Customer</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <Menu.Item
          key={"/cash-counter"}
          icon={<DollarOutlined style={menuStyle} />}
        >
          <Link to={"/cash-counter"}>Cash Counter</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item key={"/coupons"} icon={<GiftOutlined style={menuStyle} />}>
          <Link to={"/coupons"}>Coupons</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item
          key={"/campaigns"}
          icon={<NotificationOutlined style={menuStyle} />}
        >
          <Link to={"/campaigns"}>Campaigns</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["admin", "support"]) && (
        <Menu.Item
          key={"/support"}
          icon={<MessageOutlined style={menuStyle} />}
        >
          <Link to={"/support"}>Support</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item key={"/tasks"} icon={<ScheduleOutlined style={menuStyle} />}>
          <Link to={"/tasks"}>Tasks</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <Menu.Item key={"/payments"} icon={<IoCashOutline style={menuStyle} />}>
          <Link to={"/payments"}>Payments</Link>
        </Menu.Item>
      )}
      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <Menu.Item key={"/point"} icon={<IoStarOutline style={menuStyle} />}>
          <Link to={"/point"}>Point</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin", "accountant"]) && (
        <SubMenu key="refund" icon={<LaptopOutlined />} title="Refund Hub">
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/pending-refunds"}
              icon={<Loading3QuartersOutlined style={menuStyle} />}
            >
              <Link to={"/pending-refunds"}>Pending Refund</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/ready-refunds"}
              icon={<CheckCircleOutlined style={menuStyle} />}
            >
              <Link to={"/ready-refunds"}>Ready to Refund</Link>
            </Menu.Item>
          )}
          {isPermitted(roles, ["super_admin", "accountant"]) && (
            <Menu.Item
              key={"/refund-history"}
              icon={<NodeIndexOutlined style={menuStyle} />}
            >
              <Link to={"/refund-history"}>Refund History</Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {isPermitted(roles, ["admin", "accountant"]) && (
        <SubMenu key="reports" icon={<BarChartOutlined />} title="Reports">
          {isPermitted(roles, ["admin", "accountant"]) && (
            <Menu.Item
              key={"/delivery-payment-report"}
              icon={<CarOutlined style={menuStyle} />}
            >
              <Link to={"/delivery-payment-report"}>
                Delivery Payment Report
              </Link>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {isPermitted(roles, ["admin", "marketing"]) && (
        <Menu.Item key={"/gallery"} icon={<IoImageOutline style={menuStyle} />}>
          <Link to={"/gallery"}>Gallery</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["admin", "marketing"]) && (
        <Menu.Item
          key={"/bulk-notification"}
          icon={<NotificationOutlined style={menuStyle} />}
        >
          <Link to={"/bulk-notification"}>Bulk Notification</Link>
        </Menu.Item>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <SubMenu key="settings" icon={<SettingOutlined />} title="Settings">
          <Menu.Item
            key={"/settings/rates"}
            icon={<EuroCircleOutlined style={menuStyle} />}
          >
            <Link to={"/settings/rates"}>Rates & Margin</Link>
          </Menu.Item>
          <Menu.Item
            key={"/settings/shipping-charges"}
            icon={<CarOutlined style={menuStyle} />}
          >
            <Link to={"/settings/shipping-charges"}>Shipping Charges</Link>
          </Menu.Item>
        </SubMenu>
      )}

      {isPermitted(roles, ["super_admin"]) && (
        <Menu.Item
          key="/admins"
          icon={
            <UsergroupAddOutlined style={{ fontSize: "14px", width: "18px" }} />
          }
        >
          <Link to={"/admins"}>Admins</Link>
        </Menu.Item>
      )}

      <Menu.Item
        key="/SettingOutlined "
        icon={<UserOutlined style={{ fontSize: "14px", width: "18px" }} />}
      >
        <Link to={"/profile"}>Profile</Link>
      </Menu.Item>
      <Menu.Item
        key="/logout"
        onClick={() => {
          dispatch(logoutAdmin(() => {}));
          openNotificationWithIcon(
            "success",
            "Success",
            "Logged out successfully"
          );
        }}
        icon={<LogoutOutlined style={{ fontSize: "16px", width: "18px" }} />}
      >
        Logout
      </Menu.Item>
    </Menu>
  );
}
